export const PoemDyingMothOnTheTramFloor = () => {
    return (
        <div id="018" className="">
            <p>the smallness of being,</p>
            <p>the loneliness of being,</p>
            <p>light filters down through the leaves,</p>
            <p>so many things to question and receive no reply from,</p>
            <p>to contact and</p>
            <p>never hear back from,</p>
            <p>the reasons will be</p>
            <p>subsequently laid out on the ground </p>
            <p>and then swept away and possibly stepped on,</p>
            <p>made small and then scattered,</p>
            <p>the reasons will be</p>
            <p>doled out to moth larvae to chew on.</p>
            <br />
            <p>can you turn this into more than it is right now</p>
            <p>&amp; maybe push this unmovable object</p>
            <p>&amp; maybe halt this unstoppable thing?</p>
            <p>sometimes</p>
            <p>things pass by, blown away by gusts of wind</p>
            <p>and make it feel like something might be happening,</p>
            <p>and i catch myself wanting for things to mean far more</p>
            <p>than they actually do.</p>
            <br />
            <p>how do you balance out this immeasurable weight</p>
            <p>and this indefinite amount of time,</p>
            <p>a good chunk of it is just pretending</p>
            <p>that you have indeed</p>
            <p>received an answer.</p>
        </div>
    );
};
